// extracted by css-extract-rspack-plugin
module.exports =  {"button":"CrumblepathButton-opVM__button","active":"CrumblepathButton-u5OT__active","tooltip":"CrumblepathButton-SDK6__tooltip"};